/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/dashboard/models/dashboard.grid-config-item.ts.
 */
import {GridsterItem, GridsterItemComponentInterface} from 'angular-gridster2';

/**
 * Zweck: Beschreibt class DashboardGridConfigItem und ihren Daten- oder Funktionsvertrag.
 */
export class DashboardGridConfigItem implements GridsterItem {
  widget: string;
  x: number;
  y: number;
  rows: number;
  cols: number;
  layerIndex?: number;
  initCallback?: (item: GridsterItem, itemComponent: GridsterItemComponentInterface) => void;
  dragEnabled?: boolean;
  resizeEnabled?: boolean;
  compactEnabled?: boolean;
  maxItemRows?: number;
  minItemRows?: number;
  maxItemCols?: number;
  minItemCols?: number;
  minItemArea?: number;
  maxItemArea?: number;
}
